<template>
    <div class="news">
      <Header
        :headerBgc="state.headerBgc"
        :showLogo="state.showLogo"
        @titleClick="titleClick"
        @menuClick="menuClick"
        :boxShadows="state.boxShadows"
        :title-color="state.titleColor"
      />
      <div class="news_con">
        <div class="top">
          <p data-aos="fade-up" data-aos-duration="1000">{{ $t('health.pageTitle') }}</p>
        </div>
        <div class="title_name">{{ $t('health.videoGuide') }}</div>
        <div class="video_con">
          <span v-if="state.isShow" :style="{ backgroundImage: `url(${videoCoverImg})` }">
            <img class="video_play" src="../assets/img/pla.png" alt="" @click="onPlay">
          </span>
          <video
          v-else
          @play="handlePlay"
          @pause="handlePause"
          autoplay
          controls
          :src="videoSrc"/>
        </div>
        <div class="hel_detail">
          <div class="title_nam">{{ $t('health.imageTextGuide') }}</div>
          <img :src="helDetailImg" alt="">
        </div>
      </div>
      <NewFooter />
    </div>
  </template>
  
  <script setup>
  import { reactive, computed, onMounted, onUnmounted, ref } from 'vue'
  import { useAppStore } from '../store/app'
  import helsImg from '../assets/img/hels.png'
  import helsEnImg from '../assets/img/hels_en-us.png'
  import helImg from '../assets/img/hel.png'
  import helEnImg from '../assets/img/hel_en-us.png'
  const { t, locale } = useI18n()
  const localePath = useLocalePath()
  const { activeNum, setActive } = useAppStore()
  const router = useRouter()
  const { $aos } = useNuxtApp()

  const isEn = computed(() => locale.value === 'en-US')

  // 多语言视频URL：中文使用原始路径，英文在 temp/ 后插入 en-US/
  const videoSrc = computed(() => {
    const base = 'https://oss.genebiohealth.com/temp/'
    const file = '9cc758cf8e0929ac317f867e41ab50b7.mp4'
    return isEn.value ? `${base}en-US/${file}` : `${base}${file}`
  })

  // 多语言视频封面图
  const videoCoverImg = computed(() => isEn.value ? helsEnImg : helsImg)

  // 多语言图文指导图
  const helDetailImg = computed(() => isEn.value ? helEnImg : helImg)

  useSeoMeta({
    title: t('health.seoTitle'),
    description: t('health.seoDescription'),
    ogTitle: t('health.seoTitle'),
    ogDescription: t('health.seoDescription'),
    ogType: 'website',
  })
  
  const lineChange = ref(null)
  const state = reactive({
    headerBgc: '',
    showLogo: true,
    titleColor: '#fff',
    boxShadows: '',
    isShow:true
  })
  
  const titleClick = (id) => {
    if (id == 11) {
    setActive(0)
      navigateTo(localePath(`/about`))
    }else if(id==22){
      setActive(0)
      navigateTo(localePath(`/product`))
    } else if (id == 33) {
      navigateTo(localePath(`/health`))
    } else if (id == 44) {
      setActive(0)
      navigateTo(localePath(`/contact`))
    } else {
      navigateTo(localePath(`/newsCenter`))
    }
  }
  const menuClick =(e,path)=>{
    let id = +e
      navigateTo(path)
      if(path.includes('/about')){
        setActive(+id-1)
        return
      }
      if(path.includes('/product')){
        state.active = id-6
        setActive(+id-6)
        return
      }
      if(path.includes('/health')){
        return
      }
      if(path.includes('/contact')){
        state.active = id-13
        setActive(+id-13)
        return
      }
  }
  const onPlay =()=>{
    state.isShow = !state.isShow
  }
  const handlePlay =()=>{
    // console.log('play');
  }
  const handlePause =()=>{
    // console.log('pause');
  }
  const toDetail=(index)=>{
      navigateTo(localePath(`/detail/${index}`))
  }
  function handleScroll() {
    let top = Math.floor(
      document.documentElement.scrollTop || document.body.scrollTop
    )
    if (top >= 80) {
      state.headerBgc = '#fff'
      state.showLogo = false
      state.titleColor = '#000'
      state.boxShadows = '0px 1px 8px 0px rgba(0,0,0,0.09)'
    } else {
      state.headerBgc = ''
      state.showLogo = true
      state.titleColor = '#fff'
      state.boxShadows = ''
    }
  }
  onMounted(() => {
    state.active = activeNum
    $aos().init({
      easing: 'ease-out-back',
      duration: 2000,
      once: true,
    })
    window.addEventListener('scroll', handleScroll)
  })
  onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll)
  //   localStorage.removeItem('counter')
  })
  </script>
  
  <style lang="less" scoped>
  .news {
    .news_con {
      width: 100%;
      background-color: #f8f9fb;
      position: relative;
      .top {
        background: url('../assets/img/centext.png');
        background-size: cover;
        background-position: center;
        width: 100%;
        height: 200px;
        p {
          font-size: 18px;
          font-weight: 700;
          color: #fff;
          padding-top: 80px;
          text-align: center;
          text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.5);
          transition: transform 0.3s ease, color 0.3s ease;
        }
        .p_act {
          transform: translateY(-30px); /* 鼠标经过时上移文字 */
          color: #333; /* 鼠标经过时加深文字颜色 */
        }
      }
      .title_name{
        font-size: 16px;
        font-family: Alibaba PuHuiTi;
        font-weight: bold;
        color: #333333;
        padding-top: 48px;
        padding-bottom: 38px;
        text-align: center;
      }
      .title_nam{
        font-size: 16px;
        font-family: Alibaba PuHuiTi;
        font-weight: bold;
        color: #333333;
        padding-bottom: 40px;
        padding-top: 30px;
        text-align: center;
      }
      .video_con{
        text-align: center;
        margin-bottom: 20px;
        span{
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center center;
          width: 534px;
          max-width: 90%;
          height: 308px;
          line-height: 328px;
          display: inline-block;
          text-align: center;
          .video_play{
            width: 40px;
            height: 40px;
            display: inline-block;
            vertical-align: middle;
            cursor: pointer;
            }
        }
        video{
        width: 534px;
        max-width: 90%;
        height: 308px;
        object-fit: cover;
        display: block;
        margin: 0 auto;
      }
      }
      .hel_detail{
        text-align: center;
        // margin-bottom: 100px;
        img{
          width: 539px;
          max-width: 90%;
          display: block;
          margin: 0 auto;
        }
      }
    }
  }
  </style>
  